import Model from "./base/model";

class SimulationKgRange extends Model {
  resourceName() {
    return "simulation_kg_ranges";
  }

  fields() {
    return {
      simulation_table_id: "",
      kg_start: "",
      kg_end: "",

      simulation_table: {jsonApi: "hasOne", type: "simulation_tables"},
      simulation_kg_values: {jsonApi: "hasMany", type: "simulation_kg_values"},

    };
  }
}

export default new SimulationKgRange();
